import { render, staticRenderFns } from "./indicatorCom.vue?vue&type=template&id=2bf377c0&"
import script from "./indicatorCom.vue?vue&type=script&lang=js&"
export * from "./indicatorCom.vue?vue&type=script&lang=js&"
import style0 from "./indicatorCom.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports